export default class BeEndpoints {
  //general
  static BASE_BE_URL = process.env.PREACT_APP_BE_ENDPOINT_BASE_URL;
  static INITIATE_LOGIN = 'auth/initiate-login/';
  static COMPLETE_LOGIN = 'auth/verify-login';
  static LOGOUT = 'auth/logout';
  static IDENTIFY_USER = 'auth/identify-user';

  //activation endpoints
  static CAMPAIGN = 'app/campaign/get/';
  static GET_BIC = 'BIC';
  static GET_OFFERS = 'OFFERS';
  static MERCHANTS_LIST = 'app/campaign/merchants';
  static BRANDS_LIST = 'app/campaign/brands';
  static CATEGORY_LIST = 'app/campaign/categories';
  static INITIATE_REGISTRATION = 'app/registration/initiate';
  static INITIATE_TRANSACTION = 'app/transaction/initiate';
  static CONFIRM_REGISTRATION = 'app/registration/confirm';
  static INIT_CREDIT_LINE = 'app/credit-line/initiate-credit-line';
  static VERIFY_CREDIT_LINE = 'app/credit-line/verify-aivf';
  static SEND_OTP_RESET_PIN = 'auth/initiate-user-verification';
  static SET_IC_USER_COOKIE = 'app/widget/set-ic-user-cookie';
  static GET_ELIGIBLE_LENDERS = '/app/bic/check-user-eligibility';
  //dashboard endpoints
  static TXN_HISTORY = 'txn/history/all';
  static VOUCHER_DETAIL = 'txn/getVoucherDetails';

  //transaction endpoints
  static TRANSACTION_EMI_CALCULATOR = 'app/transaction/emi-calculator';
  static DETECT_USER = 'v2/smartUserDetect';
  static GET_SUD = 'api/sud/v1';
  static CONFIRM_TRANSACTION = 'app/transaction/confirm';
  static IN_TRANSACTION_NTB_INITIATE_APPLICATION =
    'app/transaction/ntb/initiate-application';
  static IN_TRANSACTION_NTB_LENDER_STATUS =
    'app/transaction/ntb/application-status';
  static IN_TRANSACTION_NTB_PRE_ELIGIBILITY =
    'app/transaction/ntb/check-pre-eligibility';

  // checkout endpoints
  static CHECKOUT_GET_ORDER_DETAILS = 'app/payment/details';
  static CHECKOUT_SEND_OTP = 'app/payment/send-otp';
  static CHECKOUT_VERIFY_OTP = 'app/payment/verify-otp';
  static CHECKOUT_PAYMENT_AUTHORIZE = 'app/payment/authorize';
  static CHECKOUT_PAYMENT_CONFIRM = 'app/payment/confirm';
  static CHECKOUT_RESEND_OTP = 'app/payment/resend-otp/';
  static CHECKOUT_ORDER_CANCEL = 'app/payment/cancel';
  static CHECKOUT_GET_KFS_DATA = 'app/payment/get-kfs-data';

  //sales App endpoints

  static SALES_CHECK_ELIGIBILITY = 'app/affordability/sa/check-eligibility';
  static SALES_PRE_CHECK_ELIGIBILITY = 'app/affordability/sa/pre-eligibility';
  static SALES_GET_EMI_DETAILS = 'app/affordability/sa/get-emi-details';
  static SALES_SEND_SHARE_CODE = 'app/affordability/sa/send-share-code';
  static SALES_VERIFY_SHARE_CODE = 'app/affordability/sa/verify-share-code';
  static SALES_SEND_NTB_SMS = 'app/affordability/sa/share-ntb-application';
  static SALES_APP_INIT = 'app/affordability/sa/init';

  //sales widget endpoints
  //TODO: apis need to be added

  static RESEND_TRANSACTION_OTP = 'app/transaction/resend-otp';
  static INITIATE_SECOND_FACTOR = 'app/transaction/initiate-second-factor/';
  static VERIFY_SECOND_FACTOR = 'app/transaction/verify-second-factor/';
  static TRANSACTION_DETAILS = 'app/transaction/details';
  static CANCEL_TRANSACTION = 'app/transaction/cancel';
  static TRACKING_TRANSACTION = 'app/transaction/track-stage';
  static SEND_OFFLINE_TXN_SMS = 'app/transaction/send-offline-txn-sms';
  static GET_POS_TRANSACTION_STATUS = 'app/transaction/get-offline-txn-status';
  static GET_POS_TRANSACTION_DETAILS =
    'app/transaction/get-offline-txn-details';
  static GET_TXN_KFS_DATA = 'app/transaction/get-kfs-data';
  static CALCULATE_TXN_KFS_DATA = 'app/transaction/calculate-kfs-data';

  // POS endpoints
  static POS_CHECK_ELIGIBILITY = 'app/pg/check-eligibility';
  static POS_TXN_INITIATE = 'app/pg/txn-initiate';

  //ab testing endpoints
  static GET_AB_TEST_VARIANT = 'app/experiments/user/variant';

  //e-mandate
  static E_MANDATE_REDIRECT_REQUEST = 'app/emandate/get-redirection-params/';

  //ntb-endpoints
  static SEND_OTP_NTB = 'app/ntb-user-acquisition/send-otp';
  static VERIFY_OTP_NTB = 'app/ntb-user-acquisition/verify-otp';
  static ELIGIBILITY_LIST = 'app/ntb-user-acquisition/eligibility';
  static NTB_SEND_APP_SMS = '/app/ntb-user-acquisition/download-app-sms';

  //ntbpq-endpoints
  static INITIATE_LENDER_NTB = 'app/ntbpq/initiate-application';
  static NTB_LENDER_LIST = 'app/ntbpq/eligible-lenders';
  static NTB_LENDER_STATUS = 'app/ntbpq/application-status';
  static CW_INITIATE_LENDER_NTB = 'app/payment/ntbpq/initiate-application';
  static CW_NTB_LENDER_LIST = 'app/payment/ntbpq/eligible-lenders';
  static CW_NTB_LENDER_STATUS = 'app/payment/ntbpq/application-status';
  static NTB_BENEFITS_INFO = 'app/ntbpq/marketplace-info';
  static NTB_LENDER_PRE_ELIGIBILITY = 'app/ntbpq/check-pre-eligibility';
  static NTB_SA_APP_INITIATE_LENDER_APPLICATION =
    'app/ntbpq/sa-app/initiate-application';

  //program-page
  static GET_ALL_CREDIT_SCHEMES = '/app/credit-scheme/all';

  //Category Page
  static GET_CATEGORY_MERCHANTS = '/app/campaign/page/get/CATEGORY';

  //Brand Page
  static GET_BRAND_DETAILS = '/app/campaign/page/get/BRAND';

  //widgets
  static POST_CHECK_USER_ELIGIBLE_EMI =
    '/app/widget/check-user-eligibility?v=1';
  static GET_EMI_INFO = '/app/widget/get-emi-info';
  static GET_HOW_TO_BUY_WIDGET = '/app/widget/how-to-buy';
  static WIDGET_SEND_APP_SMS = '/app/widget/download-app-sms';
  static WIDGET_CONFIG = '/app/widget/init';

  //odr freshdesk
  static CREATE_TICKET = 'app/odr/create-ticket';
  static VIEW_TICKET = 'app/odr/view-ticket';
  static UPDATE_TICKET = 'app/odr/update-ticket';

  //in transaction ntb
  static CONFIRM_NTB_TRANSACTION = 'app/transaction/ntb/confirm';
  static GENERIC_NTB_PRE_ELIGIBILITY =
    'app/transaction/ntb/v1/check-pre-eligibility';
}



// WEBPACK FOOTER //
// ./services/end-points/be-endpoints/index.js